// extracted by mini-css-extract-plugin
export default {"root":"NotificationsP2PDetailsLinkToCase_root__dGCpk"};